import React from 'react';
import {
    Card, CardContent, Grid, Typography, Box
} from '@mui/material';
import YouTube from 'react-youtube';
import { useTranslation } from 'react-i18next';

export default function PreviewCard({videoId = null}) {
    const { t } = useTranslation();

    const opts = {
        height: '145px',
        width: '100%',
        playerVars: {
          // https://developers.google.com/youtube/player_parameters
            mute: 1,
            autoplay: 1,
        },
      };

    const handleReady = (event) => {
      try {
        if (event.target && typeof event.target.mute === 'function') {
          event.target.mute();
        }
        if (event.target && typeof event.target.setVolume === 'function') {
          event.target.setVolume(0);
        }
      } catch (e) {}
    };

    return (
      <Card elevation={3} style={{ padding: '10px 12px', margin: 0, height: '100%', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>
        <CardContent style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', padding: 0, overflow: 'hidden' }}>
          {/* Titular en su propia línea independiente */}
          <Box sx={{ mb: 1, flexShrink: 0 }}>
            <Typography variant="h6" component="div">
              {t('preview.title')}
            </Typography>
          </Box>

          {/* Contenedor perfectamente centrado vertical y horizontalmente */}
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <div style={{
              height: 145, 
              width: '100%', 
              maxWidth: 340, 
              borderRadius: 12,
              border: '1px dashed rgba(255, 255, 255, 0.15)', 
              background: 'rgba(0, 0, 0, 0.35)',
              textAlign: 'center', 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center', 
              color: 'rgba(255, 255, 255, 0.55)',
              fontSize: '0.8rem',
              overflow: 'hidden',
              padding: '16px 20px',
              boxSizing: 'border-box'
            }}>
              {videoId ? (
                <YouTube videoId={videoId} opts={opts} onReady={handleReady} style={{ width: '100%', height: '100%' }} />
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
                  <span style={{ fontSize: '1.4rem', opacity: 0.7 }}>👁️</span>
                  <span style={{ fontWeight: 600, color: 'rgba(255, 255, 255, 0.8)' }}>
                    {t('preview.emptyTitle')}
                  </span>
                  <span style={{ fontSize: '0.72rem', color: 'rgba(255, 255, 255, 0.45)', lineHeight: 1.3 }}>
                    {t('preview.emptyDesc')}
                  </span>
                </div>
              )}
            </div>
          </Box>
        </CardContent>
      </Card>
    );
}             